import { useState, useContext, useEffect } from 'react';
import _ from 'lodash';

import AssetListContext from '../app/context/assetListContext';
import AppStateContext from "../app/context/appStateContext";

const conditionMapping = {
  "1 (VERY GOOD)": 5,
  "2 (GOOD)": 4,
  "3 (MODERATE)": 3,
  "4 (POOR)": 2,
  "5 (VERY POOR)": 1,
};

const useAssetFilterForm = () => {
  const { assetFilters, assetList, updateFilteredAssetList, deleteFilters } = useContext(AssetListContext);
  const { contractList, selectedCustomerId } = useContext(AppStateContext);

  const [ buildingFilters, setBuildingFilters ] = useState({});

  useEffect(() => {
    initialiseBuildings();
  },[]);

  const initialiseBuildings = () => {
    let buildings = {};
    Object.keys(contractList[selectedCustomerId]).map((item,index) => {
      buildings[item] = false;
    });
    setBuildingFilters(buildings);
  };

  const handleSubmit = () => {
    let newAssetList = [];
    newAssetList = assetList;
    let buildingList = _.keys(_.pickBy(buildingFilters));
    updateFilteredAssetList(
      newAssetList.filter(asset => {
        let finalBoolean = true;
        if(buildingList.length == 0 && assetFilters.conditionFilter == -1) return true;

        if(assetFilters.conditionFilter != -1) finalBoolean = finalBoolean && (asset.Condition == undefined && assetFilters.conditionFilter == 0 ||
          conditionMapping[asset.Condition] === assetFilters.conditionFilter);

        if(buildingList.length) finalBoolean = finalBoolean && buildingList.includes(asset.ContractNo);

        return finalBoolean;
      })
    )
  };

  const handleBuildingChange = (element: string) => {
    setBuildingFilters(prevState => {
      const newState = {...prevState};

      let newBuilding = {};
      newBuilding[element] = !newState[element];
      return _.merge(newState, newBuilding);
    })
  };

  const clearFilter = () => {
    initialiseBuildings();
    deleteFilters();
  };

  return {
    buildingFilters,
    handleSubmit,
    handleBuildingChange,
    clearFilter,
  }
};

export default useAssetFilterForm;